import subsDao from '../../../../dao/subsDao';
import accountDao from '../../../../dao/accountDao';
import {loadAuth} from '../../../../components/auth/reducers';
import {toast} from 'react-toastify';
import {Trans} from 'react-i18next';
import React from 'react';

const RESET = 'pages/generalsettings/accountsettings/updateaccount/RESET';
const QUERY_ACCOUNT_SUMMARY =
  'pages/generalsettings/accountsettings/updateaccount/QUERY_ACCOUNT_SUMMARY';
const QUERY_ACCOUNT_SUMMARY_SUCCESS =
  'pages/generalsettings/accountsettings/updateaccount/QUERY_ACCOUNT_SUMMARY_SUCCESS';
const UPDATE_CUSTOMER =
  'pages/generalsettings/accountsettings/updateaccount/UPDATE_CUSTOMER';
const UPDATE_CUSTOMER_SUCCESS =
  'pages/generalsettings/accountsettings/updateaccount/UPDATE_CUSTOMER_SUCCESS';
const UPDATE_RENEWAL_TYPE =
  'pages/generalsettings/accountsettings/updateaccount/UPDATE_RENEWAL_TYPE';
const UPDATE_RENEWAL_TYPE_SUCCESS =
  'pages/generalsettings/accountsettings/updateaccount/UPDATE_RENEWAL_TYPE_SUCCESS';
const SEND_CONFIRM_EMAIL =
  'pages/generalsettings/accountsettings/updateaccount/SEND_CONFIRM_EMAIL';
const SEND_CONFIRM_EMAIL_SUCCESS =
  'pages/generalsettings/accountsettings/updateaccount/SEND_CONFIRM_EMAIL_SUCCESS';
const SEND_CONFIRM_EMAIL_FAIL =
  'pages/generalsettings/accountsettings/updateaccount/SEND_CONFIRM_EMAIL_FAIL';
const QUERY_SUBSCRIPTION_DOWNGRADE =
  'pages/generalsettings/accountsettings/updateaccount/QUERY_SUBSCRIPTION_DOWNGRADE';
const QUERY_SUBSCRIPTION_DOWNGRADE_SUCCESS =
  'pages/generalsettings/accountsettings/updateaccount/QUERY_SUBSCRIPTION_DOWNGRADE_SUCCESS';
const QUERY_ADDONS_SETS =
  'pages/generalsettings/accountsettings/updateaccount/QUERY_ADDONS_SETS';
const QUERY_ADDONS_SETS_SUCCESS =
  'pages/generalsettings/accountsettings/updateaccount/QUERY_ADDONS_SETS_SUCCESS';
const CANCEL_DOWNGRADE =
  'pages/generalsettings/accountsettings/updateaccount/CANCEL_DOWNGRADE';
const CANCEL_DOWNGRADE_SUCCESS =
  'pages/generalsettings/accountsettings/updateaccount/CANCEL_DOWNGRADE_SUCCESS';

const initialState = {
  isLoaded: false,
  isDowngradeLoaded: false,
  isAddOnsSetLoaded: false,
  downgradeLoader: false,
  isSendingConfirmEmail: false,
  subscriptionDowngrade: {},
  addOnsSets: {},
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case RESET:
      return {...initialState};
    case QUERY_ACCOUNT_SUMMARY:
      return {
        ...state,
        isLoaded: false,
      };
    case QUERY_ACCOUNT_SUMMARY_SUCCESS:
      return {
        ...state,
        isLoaded: true,
      };
    case SEND_CONFIRM_EMAIL:
      return {
        ...state,
        isSendingConfirmEmail: true,
      };
    case SEND_CONFIRM_EMAIL_SUCCESS:
    case SEND_CONFIRM_EMAIL_FAIL:
      return {
        ...state,
        isSendingConfirmEmail: false,
      };
    case QUERY_SUBSCRIPTION_DOWNGRADE:
      return {
        ...state,
        isDowngradeLoaded: false,
      };
    case QUERY_SUBSCRIPTION_DOWNGRADE_SUCCESS:
      return {
        ...state,
        isDowngradeLoaded: true,
        subscriptionDowngrade: action.json,
      };
    case QUERY_ADDONS_SETS:
      return {
        ...state,
        isAddOnsSetLoaded: false,
      };
    case QUERY_ADDONS_SETS_SUCCESS:
      return {
        ...state,
        isAddOnsSetLoaded: true,
        addOnsSets: action.json,
      };
    case CANCEL_DOWNGRADE:
      return {
        ...state,
        downgradeLoader: true,
      };
    case CANCEL_DOWNGRADE_SUCCESS:
      return {
        ...state,
        downgradeLoader: false,
      };
    default:
      return state;
  }
};

export function reset() {
  return {type: RESET};
}

export function queryAccountSummary() {
  return dispatch => {
    dispatch({type: QUERY_ACCOUNT_SUMMARY});

    return accountDao.queryAccountSummary().then(json => {
      dispatch({type: QUERY_ACCOUNT_SUMMARY_SUCCESS});
      return json;
    });
  };
}

export function queryAddOnsSets() {
  return dispatch => {
    dispatch({type: QUERY_ADDONS_SETS});

    return subsDao.queryAddOnsSets().then(json => {
      return dispatch({type: QUERY_ADDONS_SETS_SUCCESS, json});
    });
  };
}

export function querySubscriptionDowngrade() {
  return dispatch => {
    dispatch({type: QUERY_SUBSCRIPTION_DOWNGRADE});

    return subsDao.querySubscriptionDowngrade().then(json => {
      return dispatch({type: QUERY_SUBSCRIPTION_DOWNGRADE_SUCCESS, json});
    });
  };
}

export function updateCustomer(
  customer,
  handleLoading = () => {},
  solutionType,
  reloadAuth = true
) {
  return async dispatch => {
    if (customer.subscription) {
      await dispatch(
        updateRenewalType(customer.subscription.isRenewable, solutionType)
      );
    }

    dispatch({type: UPDATE_CUSTOMER});

    return accountDao.updateCustomer(customer).then(json => {
      dispatch({type: UPDATE_CUSTOMER_SUCCESS});
      if (customer.subscription) {
        setTimeout(() => {
          handleLoading();
          dispatch(loadAuth());
        }, 3000);
      } else if (reloadAuth) {
        dispatch(loadAuth());
      }
      toast.success(<Trans i18nKey="toast.success.success">Success</Trans>);
      return json;
    });
  };
}

export function updateRenewalType(isRenewable, solutionType) {
  return dispatch => {
    dispatch({type: UPDATE_RENEWAL_TYPE});

    return subsDao.updateRenewalType(isRenewable, solutionType).then(json => {
      dispatch({type: UPDATE_RENEWAL_TYPE_SUCCESS});
      return json;
    });
  };
}

export function sendConfirmEmail() {
  return dispatch => {
    dispatch({type: SEND_CONFIRM_EMAIL});

    return accountDao
      .sendConfirmEmail()
      .then(json => {
        dispatch({type: SEND_CONFIRM_EMAIL_SUCCESS});
        return json;
      })
      .catch(error => {
        dispatch({type: SEND_CONFIRM_EMAIL_FAIL});
        return Promise.reject(error);
      });
  };
}

export function cancelDowngrade() {
  return dispatch => {
    dispatch({type: CANCEL_DOWNGRADE});
    return subsDao.cancelDowngrade('update');
  };
}

export function cancelDowngradeSuccess() {
  return {
    type: CANCEL_DOWNGRADE_SUCCESS,
  };
}
